
import React from 'react';
import FormInputTagsItem from './FormInputTagsItem';
import RepairSearch from '../../search/RepairSearch';

export default (props) => {
  return <FormInputTagsItem {...props} inputComponent={RepairSearch} />;
};
